import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Datepicker from "vuejs-datepicker";
// @ts-ignore
import ReportCollection from "@/classes/ReportCollection";
let UserHours = class UserHours extends Vue {
    loadAdminTimeReports() {
        this.$data.loading = true;
        this.$store
            .dispatch("loadAdminTimeReportsAsync", {
            date: this.$store.getters.getSelectedDate,
        })
            .then((result) => {
            this.$data.reports = new ReportCollection();
            this.$data.reports.importReportObjectsFromJson(result.data);
            // this.calculateTotal(); //calculate the total hours
            this.$data.loading = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
            this.$data.loading = false;
        });
    }
    //loads the employees as an admin
    loadUsers() {
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            console.log(result.data);
            // this.$store.commit("setGlobalEmployeesAdmin", result.data);
            this.$data.users = result.data;
            //once we have the users we load the reports (we need the users to be able to calculate the total)
            this.$store
                .dispatch("loadAdminTimeReportsAsync", {
                date: this.$store.getters.getSelectedDate,
            })
                .then((result2) => {
                this.$data.reports = new ReportCollection();
                this.$data.reports.importReportObjectsFromJson(result2.data);
                // this.calculateTotal(); //calculate the total hours
                this.$data.preloaded = true;
            })
                .catch((err) => {
                this.$data.preloaded = true;
                window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
            });
        })
            .catch((err) => {
            this.$data.preloaded = true;
            window.errorHandler.logError(err, "UserHours.vue - loadAdminEmployees");
        });
    }
    convertToCurrency(value) {
        return Number(value).toLocaleString("se");
    }
    calculateTotal() {
        const summary = [];
        let allBillable = 0;
        let allHours = 0;
        const users = this.getUserIds();
        users.forEach((user) => {
            let allBillableCustomer = 0;
            let allHoursCustomer = 0;
            let userReports = this.generate(user);
            if (this.$data.filter !== "") {
                userReports = this.generate(user).filter((report) => {
                    for (const prop in report) {
                        if (Object.prototype.hasOwnProperty.call(report, prop)) {
                            const propVal = "" + report[prop];
                            if (propVal
                                .toString()
                                .toLowerCase()
                                .indexOf(this.$data.filter.toLowerCase().trim()) !== -1) {
                                return true;
                            }
                        }
                    }
                });
            }
            userReports.forEach((report) => {
                allHours += report.totalHours;
                allHoursCustomer += report.totalHours;
                if (report.billable === true) {
                    allBillable += report.totalHours;
                    allBillableCustomer += report.totalHours;
                }
            });
            summary[user] = {
                tHours: allHoursCustomer,
                tBillable: allBillableCustomer,
            };
        });
        //@ts-ignore
        summary["total"] = {
            tHours: allHours,
            tBillable: allBillable,
        };
        this.$data.totalHours = summary;
    }
    getUserIds() {
        const customerNames = [
            ...new Set(this.$data.reports.reports.map((x) => x.userId)),
        ];
        return customerNames.sort((a, b) => (a < b ? -1 : 1));
    }
    getUserIdsWithNames() {
        const customerNames = [
            ...new Set(this.$data.reports.reports.map((x) => x.userId)),
        ];
        const arrayOfUsers = customerNames.map((userId) => {
            const user = this.getUser(userId);
            return { userId, fullName: `${user.firstName} ${user.lastName}` };
        });
        return arrayOfUsers.sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
    getReportsForUser(userId) {
        const userReports = this.$data.reports.reports.filter((report) => {
            return report.userId === userId;
        });
        return userReports;
    }
    getTariffIdsForUser(userId) {
        const userTariffs = this.getReportsForUser(userId);
        const tariffs = [...new Set(userTariffs.map((x) => x.tariffId))];
        return tariffs;
    }
    getReportsForTariffUser(userId, tariffId) {
        const reports = this.$data.reports.reports.filter((report) => {
            return report.tariffId === tariffId && report.userId === userId;
        });
        return reports; //.map((report: any, i:number) => {
        // if(i === 0) console.log(report)
        // delete report.id
        // delete report.comment;
        // return report;
        // });
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
    getUser(userId) {
        return this.$data.users.find((user) => user.id === userId);
    }
    getName(userId) {
        const user = this.$data.users.find((user) => user.id === userId);
        if (!user)
            return "";
        return `${user.firstName} ${user.lastName}`;
    }
    generateDense(userId) {
        const orgArray = this.generate(userId);
        return orgArray.map((report) => {
            const { customerName, userName, tariffName, billable, totalHours } = report;
            return {
                customerName,
                userName,
                tariffName,
                billable,
                totalHours,
            };
        });
    }
    generate(userId) {
        const denseArray = [];
        const tariffIds = this.getTariffIdsForUser(userId);
        tariffIds.forEach((tariffId) => {
            const reports = this.getReportsForTariffUser(userId, tariffId);
            let totalHours = 0;
            reports.forEach((report) => {
                totalHours += report.hours;
            });
            const returnObject = reports[0];
            returnObject.totalHours = totalHours;
            const userObject = this.getUser(userId);
            returnObject.userName = `${userObject.firstName} ${userObject.lastName}`;
            denseArray.push(returnObject);
        });
        return denseArray;
    }
    selectPreviousMonth() {
        const newDate = window.dateHandler
            .subtractMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.loadAdminTimeReports();
        this.getDateInfo();
    }
    selectNextMonth() {
        const newDate = window.dateHandler
            .addMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.loadAdminTimeReports();
        this.getDateInfo();
    }
};
UserHours = __decorate([
    Component({
        data() {
            return {
                customerItems: [],
                theme: this.$store.getters.getTheme,
                userHeadings: [
                    {
                        text: "Customer",
                        value: "customerName",
                        width: "25%",
                        align: "left",
                    },
                    { text: "User", value: "userName", width: "0%", align: " d-none" },
                    { text: "Tariff", value: "tariffName", width: "25%", align: "start" },
                    { text: "Billable", value: "billable", width: "25%", align: "start" },
                    { text: "Hours", value: "totalHours", width: "25%", align: "start" },
                ],
                // totalHours: null,
                selectedDate: this.$store.getters.getSelectedDate,
                //nya
                reports: null,
                users: null,
                groupedCustomers: null,
                filter: "",
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                awaitingFilter: false,
                loading: false,
                preloaded: false,
            };
        },
        watch: {
        // filter: function (newFilter: string) {
        // if (!this.$data.awaitingFilter) {
        //   setTimeout(() => {
        //     this.calculateTotal();
        //     this.$data.awaitingFilter = false;
        //   }, 500); // 1 sec delay
        // }
        // this.$data.filter = newFilter;
        // this.$data.awaitingFilter = true;
        // this.calculateTotal();
        // },
        },
        computed: {
            totalHours() {
                const summary = [];
                let allBillable = 0;
                let allHours = 0;
                const users = this.getUserIds();
                users.forEach((user) => {
                    let allBillableCustomer = 0;
                    let allHoursCustomer = 0;
                    let userReports = this.generate(user);
                    if (this.$data.filter !== "") {
                        userReports = this.generate(user).filter((report) => {
                            for (const prop in report) {
                                if (Object.prototype.hasOwnProperty.call(report, prop)) {
                                    const propVal = "" + report[prop];
                                    if (propVal
                                        .toString()
                                        .toLowerCase()
                                        .indexOf(this.$data.filter.toLowerCase().trim()) !== -1) {
                                        return true;
                                    }
                                }
                            }
                        });
                    }
                    userReports.forEach((report) => {
                        allHours += report.totalHours;
                        allHoursCustomer += report.totalHours;
                        if (report.billable === true) {
                            allBillable += report.totalHours;
                            allBillableCustomer += report.totalHours;
                        }
                    });
                    summary[user] = {
                        tHours: allHoursCustomer,
                        tBillable: allBillableCustomer,
                    };
                });
                //@ts-ignore
                summary["total"] = {
                    tHours: allHours,
                    tBillable: allBillable,
                };
                return summary;
            },
        },
        mounted() {
            this.loadUsers();
            this.$store.commit("setSelectedDate", {
                date: this.$store.getters.getSelectedDate,
            });
            this.getDateInfo();
        },
        components: {
            Datepicker,
            IconBox,
            IconBoxContent,
            WhiteBox,
        },
    })
], UserHours);
export default UserHours;
